import { broadcastList, broadcastById, createBroadcast } from '@/services/broadcast.service'

export default {
  namespaced: true,
  state: {
    broadcasts: { data: [], meta: { pagination: { total: 0 } } },
    current: null,
    status: 'init',
    detailStatus: 'init',
  },
  getters: {
    getBroadcasts: s => s.broadcasts,
    getCurrent: s => s.current,
    getStatus: s => s.status,
    getDetailStatus: s => s.detailStatus,
  },
  mutations: {
    SET_BROADCASTS(state, value) { state.broadcasts = value },
    SET_CURRENT(state, value) { state.current = value },
    SET_STATUS(state, value) { state.status = value },
    SET_DETAIL_STATUS(state, value) { state.detailStatus = value },
  },
  actions: {
    async fetchBroadcasts({ commit }, params) {
      commit('SET_STATUS', 'pending')
      try {
        const { data } = await broadcastList(params)
        commit('SET_BROADCASTS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_STATUS', 'init')
      }
    },

    async fetchBroadcastById({ commit }, id) {
      commit('SET_DETAIL_STATUS', 'pending')
      try {
        const { data } = await broadcastById(id)
        commit('SET_CURRENT', data.data || data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_DETAIL_STATUS', 'init')
      }
    },

    async sendBroadcast(_, payload) {
      const { data } = await createBroadcast(payload)
      return data
    },
  },
}
